import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as apiManuMngt from 'apiSaga/apiManuMngt';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/
const INIT_MANU_MNGT_RESP = 'manu/INIT_MANU_MNGT_RESP';
const INIT_MANU_LIST_RESP = 'manu/INIT_MANU_LIST_RESP';
const INIT_MEMBER_LIST_RESP = 'manu/INIT_MEMBER_LIST_RESP';
const INIT_CENTER_LIST_RESP = 'manu/INIT_CENTER_LIST_RESP';
const INIT_MANU_INSERT_RESP = 'manu/INIT_MANU_INSERT_RESP';
const INIT_MANU_CHANGE_RESP = 'manu/INIT_MANU_CHANGE_RESP';
const INIT_MANU_DELETE_RESP = 'manu/INIT_MANU_DELETE_RESP';
const INIT_MANU_DETAIL_RESP = 'manu/INIT_MANU_DETAIL_RESP';
const INIT_MANU_UPLOAD_RESP = 'manu/INIT_MANU_UPLOAD_RESP';
const INIT_MANU_CONFIRM_RESP = 'manu/INIT_MANU_CONFIRM_RESP';
const INIT_MANU_REJECT_RESP = 'manu/INIT_MANU_REJECT_RESP';
const INIT_MANU_UPDATE_RESP = 'manu/INIT_MANU_UPDATE_RESP';
const INIT_EXCEL_MANU_LIST_DOWNLOAD_RESP = 'manu/INIT_EXCEL_MANU_LIST_DOWNLOAD_RESP';
const INIT_ARCHIVEFILE_DOWNLOAD_RESP = 'manu/INIT_ARCHIVEFILE_DOWNLOAD_RESP';
/*************************************************************************************************************** */
const GET_MANU_LIST = 'manu/GET_MANU_LIST';
const GET_MANU_LIST_SUCCESS = 'manu/GET_MANU_LIST_SUCCESS'
const GET_MANU_LIST_FAILURE = 'manu/GET_MANU_LIST_FAILURE'

const GET_MEMBER_LIST = 'manu/GET_MEMBER_LIST';
const GET_MEMBER_LIST_SUCCESS = 'manu/GET_MEMBER_LIST_SUCCESS'
const GET_MEMBER_LIST_FAILURE = 'manu/GET_MEMBER_LIST_FAILURE'

const GET_CENTER_LIST = 'manu/GET_CENTER_LIST';
const GET_CENTER_LIST_SUCCESS = 'manu/GET_CENTER_LIST_SUCCESS'
const GET_CENTER_LIST_FAILURE = 'manu/GET_CENTER_LIST_FAILURE'

const GET_MANU_CODE_LIST = 'manu/GET_MANU_CODE_LIST';
const GET_MANU_CODE_LIST_SUCCESS = 'manu/GET_MANU_CODE_LIST_SUCCESS';
const GET_MANU_CODE_LIST_FAILURE = 'manu/GET_MANU_CODE_LIST_FAILURE';

const INSERT_MANU_LIST = 'manu/INSERT_MANU_LIST';
const INSERT_MANU_LIST_SUCCESS = 'manu/INSERT_MANU_LIST_SUCCESS';
const INSERT_MANU_LIST_FAILURE = 'manu/INSERT_MANU_LIST_FAILURE';

const CHANGE_MANU_LIST = 'manu/CHANGE_MANU_LIST';
const CHANGE_MANU_LIST_SUCCESS = 'manu/CHANGE_MANU_LIST_SUCCESS';
const CHANGE_MANU_LIST_FAILURE = 'manu/CHANGE_MANU_LIST_FAILURE';

const DELETE_MANU_LIST = 'manu/DELETE_MANU_LIST';
const DELETE_MANU_LIST_SUCCESS = 'manu/DELETE_MANU_LIST_SUCCESS';
const DELETE_MANU_LIST_FAILURE = 'manu/DELETE_MANU_LIST_FAILURE';

const DETAIL_MANU_LIST = 'manu/DETAIL_MANU_LIST';
const DETAIL_MANU_LIST_SUCCESS = 'manu/DETAIL_MANU_LIST_SUCCESS';
const DETAIL_MANU_LIST_FAILURE = 'manu/DETAIL_MANU_LIST_FAILURE';

const UPLOAD_MANU_LIST = 'manu/UPLOAD_MANU_LIST';
const UPLOAD_MANU_LIST_SUCCESS = 'manu/UPLOAD_MANU_LIST_SUCCESS';
const UPLOAD_MANU_LIST_FAILURE = 'manu/UPLOAD_MANU_LIST_FAILURE';

const CONFIRM_MANU_LIST = 'manu/CONFIRM_MANU_LIST';
const CONFIRM_MANU_LIST_SUCCESS = 'manu/CONFIRM_MANU_LIST_SUCCESS';
const CONFIRM_MANU_LIST_FAILURE = 'manu/CONFIRM_MANU_LIST_FAILURE';

const REJECT_MANU_LIST = 'manu/REJECT_MANU_LIST';
const REJECT_MANU_LIST_SUCCESS = 'manu/REJECT_MANU_LIST_SUCCESS';
const REJECT_MANU_LIST_FAILURE = 'manu/REJECT_MANU_LIST_FAILURE';

const DOWNLOAD_MANU_LIST = 'manu/DOWNLOAD_MANU_LIST';
const DOWNLOAD_MANU_LIST_SUCCESS = 'manu/DOWNLOAD_MANU_LIST_SUCCESS';
const DOWNLOAD_MANU_LIST_FAILURE = 'manu/DOWNLOAD_MANU_LIST_FAILURE';

const UPDATE_MANU_LIST = 'manu/UPDATE_MANU_LIST';
const UPDATE_MANU_LIST_SUCCESS = 'manu/UPDATE_MANU_LIST_SUCCESS';
const UPDATE_MANU_LIST_FAILURE = 'manu/UPDATE_MANU_LIST_FAILURE';

const EXCEL_MANU_LIST_DOWNLOAD = 'manu/EXCEL_MANU_LIST_DOWNLOAD'
const EXCEL_MANU_LIST_DOWNLOAD_SUCCESS = 'manu/EXCEL_MANU_LIST_DOWNLOAD_SUCCESS'
const EXCEL_MANU_LIST_DOWNLOAD_FAILURE = 'manu/EXCEL_MANU_LIST_DOWNLOAD_FAILURE'

const ARCHIVEFILE_DOWNLOAD = 'manu/ARCHIVEFILE_DOWNLOAD';
const ARCHIVEFILE_DOWNLOAD_SUCCESS = 'manu/ARCHIVEFILE_DOWNLOAD_SUCCESS';
const ARCHIVEFILE_DOWNLOAD_FAILURE = 'manu/ARCHIVEFILE_DOWNLOAD_FAILURE';

/*************************************************************************************************************** */
export const initManuMngtResp = createAction(INIT_MANU_MNGT_RESP);
export const initManuListResp = createAction(INIT_MANU_LIST_RESP);
export const initGetMemberListResp = createAction(INIT_MEMBER_LIST_RESP);
export const initGetCenterListResp = createAction(INIT_CENTER_LIST_RESP);
export const initManuInsertResp = createAction(INIT_MANU_INSERT_RESP);
export const initManuChangeResp = createAction(INIT_MANU_CHANGE_RESP);
export const initDeleteManuListResp = createAction(INIT_MANU_DELETE_RESP);
export const initManuDetailResp = createAction(INIT_MANU_DETAIL_RESP);
export const initDetailManuListResp = createAction(INIT_MANU_DETAIL_RESP);
export const initUploadManuListResp = createAction(INIT_MANU_UPLOAD_RESP);
export const initConfirmManuListResp = createAction(INIT_MANU_CONFIRM_RESP);
export const initRejectManuListResp = createAction(INIT_MANU_REJECT_RESP);
export const initUpdateManuListResp = createAction(INIT_MANU_UPDATE_RESP);
export const initExcelManuListDownloadResp = createAction(INIT_EXCEL_MANU_LIST_DOWNLOAD_RESP);
export const initArchivefileDownloadResp = createAction(INIT_ARCHIVEFILE_DOWNLOAD_RESP);

/*************************************************************************************************************** */
export const getManuList = createAction(GET_MANU_LIST, reqParam => reqParam);
export const getMemberList = createAction(GET_MEMBER_LIST, reqParam => reqParam);
export const getCenterList = createAction(GET_CENTER_LIST, reqParam => reqParam);
export const getManuCodeList = createAction(GET_MANU_CODE_LIST);
export const insertManuList = createAction(INSERT_MANU_LIST, dataParam => dataParam);
export const changeManuList = createAction(CHANGE_MANU_LIST, dataParam => dataParam);
export const deleteManuList = createAction(DELETE_MANU_LIST, (formData) => (formData));
export const detailManuList = createAction(DETAIL_MANU_LIST, (agcySeq) => (agcySeq));
export const uploadManuList = createAction(UPLOAD_MANU_LIST, (formData) => formData);
export const confirmManuList = createAction(CONFIRM_MANU_LIST, (formData) => formData);
export const rejectManuList = createAction(REJECT_MANU_LIST, (formData) => formData);
export const downloadManuList = createAction(DOWNLOAD_MANU_LIST, reqParam => reqParam);
export const updateManuList = createAction(UPDATE_MANU_LIST, dataParam => dataParam);
export const excelManuListDownload = createAction(EXCEL_MANU_LIST_DOWNLOAD);
export const ArchivefileDownload = createAction(ARCHIVEFILE_DOWNLOAD, (agcySeq) => agcySeq);

/*************************************************************************************************************** */
export const getManuListSaga = createRequestSaga(GET_MANU_LIST, apiManuMngt.getManuList);
export const getMemberListSaga = createRequestSaga(GET_MEMBER_LIST, apiManuMngt.getMemberList);
export const getCenterListSaga = createRequestSaga(GET_CENTER_LIST, apiManuMngt.getCenterList);
export const getManuCodeListSaga = createRequestSaga(GET_MANU_CODE_LIST, apiManuMngt.getManuCodeList);
export const insertManuListSaga = createRequestSaga(INSERT_MANU_LIST, apiManuMngt.insertManuList);
export const changeManuListSaga = createRequestSaga(CHANGE_MANU_LIST, apiManuMngt.changeManuList);
export const deleteManuListSaga = createRequestSaga(DELETE_MANU_LIST, apiManuMngt.deleteManuList);
export const detailManuListSaga = createRequestSaga(DETAIL_MANU_LIST, apiManuMngt.detailManuList);
export const uploadManuListSaga = createRequestSaga(UPLOAD_MANU_LIST, apiManuMngt.uploadManuList);
export const confirmManuListSaga = createRequestSaga(CONFIRM_MANU_LIST, apiManuMngt.confirmManuList);
export const rejectManuListSaga = createRequestSaga(REJECT_MANU_LIST, apiManuMngt.rejectManuList);
export const downloadManuListSaga = createRequestSaga(DOWNLOAD_MANU_LIST, apiManuMngt.downloadManuList);
export const updateManuListSaga = createRequestSaga(UPDATE_MANU_LIST, apiManuMngt.updateManuList);
export const excelManuListDownloadSaga = createRequestSaga(EXCEL_MANU_LIST_DOWNLOAD, apiManuMngt.excelManuListDownload);
export const ArchivefileDownloadSaga = createRequestSaga(
    ARCHIVEFILE_DOWNLOAD,
    apiManuMngt.ArchivefileDownload
  );


export function* apiManuMngtSaga() {
    yield takeLatest(GET_MANU_LIST, getManuListSaga)
    yield takeLatest(GET_MEMBER_LIST, getMemberListSaga)
    yield takeLatest(GET_CENTER_LIST, getCenterListSaga)
    yield takeLatest(GET_MANU_CODE_LIST, getManuCodeListSaga)
    yield takeLatest(INSERT_MANU_LIST, insertManuListSaga)
    yield takeLatest(CHANGE_MANU_LIST, changeManuListSaga)
    yield takeLatest(DELETE_MANU_LIST, deleteManuListSaga)
    yield takeLatest(DETAIL_MANU_LIST, detailManuListSaga)
    yield takeLatest(UPLOAD_MANU_LIST, uploadManuListSaga)
    yield takeLatest(CONFIRM_MANU_LIST, confirmManuListSaga)
    yield takeLatest(REJECT_MANU_LIST, rejectManuListSaga)
    yield takeLatest(DOWNLOAD_MANU_LIST, downloadManuListSaga)
    yield takeLatest(UPDATE_MANU_LIST, updateManuListSaga)
    yield takeLatest(EXCEL_MANU_LIST_DOWNLOAD, excelManuListDownloadSaga)
    yield takeLatest(ARCHIVEFILE_DOWNLOAD, ArchivefileDownloadSaga)
}

/*************************************************************************************************************** */
const initialState = {
    getManuListResp: null,
    getMemberListResp: null,
    getCenterListResp: null,
    excelManuListDownloadResp: null,
    detailManuListResp: null,
    uploadManuListResp: null,
    updateManuListResp: null,
    confirmManuListResp: null,
    rejectManuListResp: null,
    deleteManuListResp: null,
    ArchivefileDownloadResp: null,
}

const apiManuMngtResp = handleActions(
    {
        [INIT_MANU_MNGT_RESP]: () => ({
            getManuListResp: null,
            excelManuListDownloadResp: null,
        }),
        [INIT_MANU_LIST_RESP]: (state) => ({
            ...state,
            getManuListResp: null
        }),
        [INIT_EXCEL_MANU_LIST_DOWNLOAD_RESP]: (state) => ({
            ...state,
            excelManuListDownloadResp: null
        }),
        [INIT_MANU_UPDATE_RESP]: (state) => ({
            ...state,
            updateManuListResp: null
        }),
        [INIT_MANU_UPLOAD_RESP]: (state) => ({
            ...state,
            uploadManuListResp: null
        }),
        [INIT_MANU_DELETE_RESP]: (state) => ({
            ...state,
            deleteManuListResp: null
        }),
        [GET_MANU_LIST_SUCCESS]: (state, action) => ({
            ...state,
            getManuListResp: action.payload
        }),
        [GET_MANU_LIST_FAILURE]: (state, action) => ({
            ...state,
            getManuListResp: {
                result_code: 'E999',
                result_message: action.payload
            }
        }),

        [GET_MEMBER_LIST_SUCCESS]: (state, action) => ({
            ...state,
            getMemberListResp: action.payload
        }),
        [GET_MEMBER_LIST_FAILURE]: (state, action) => ({
            ...state,
            getMemberListResp: {
                result_code: 'E999',
                result_message: action.payload
            }
        }),

        [GET_CENTER_LIST_SUCCESS]: (state, action) => ({
            ...state,
            getCenterListResp: action.payload
        }),
        [GET_CENTER_LIST_FAILURE]: (state, action) => ({
            ...state,
            getCenterListResp: {
                result_code: 'E999',
                result_message: action.payload
            }
        }),

        [UPLOAD_MANU_LIST_SUCCESS]: (state, action) => ({
            ...state,
            uploadManuListResp: action.payload,
        }),
        [UPLOAD_MANU_LIST_FAILURE]: (state, action) => ({
            ...state,
            uploadManuListResp: {
            result_code: 'E999',
            result_message: action.payload,
           }
        }),

        [CONFIRM_MANU_LIST_SUCCESS]: (state, action) => ({
            ...state,
            confirmManuListResp: action.payload,
        }),
        [CONFIRM_MANU_LIST_FAILURE]: (state, action) => ({
            ...state,
            confirmManuListResp: {
            result_code: 'E999',
            result_message: action.payload,
           }
        }),

        [REJECT_MANU_LIST_SUCCESS]: (state, action) => ({
            ...state,
            rejectManuListResp: action.payload,
        }),
        [REJECT_MANU_LIST_FAILURE]: (state, action) => ({
            ...state,
            rejectManuListResp: {
            result_code: 'E999',
            result_message: action.payload,
           }
        }),

        [DELETE_MANU_LIST_SUCCESS]: (state, action) => ({
            ...state,
            deleteManuListResp: action.payload,
        }),
        [DELETE_MANU_LIST_FAILURE]: (state, action) => ({
            ...state,
            deleteManuListResp: {
            result_code: 'E999',
            result_message: action.payload,
           }
        }),

        [DETAIL_MANU_LIST_SUCCESS]: (state, action) => ({
            ...state,
            detailManuListResp: action.payload,
        }),
        [DETAIL_MANU_LIST_FAILURE]: (state, action) => ({
            ...state,
            detailManuListResp: {
            result_code: 'E999',
            result_message: action.payload,
           }
        }),

        [UPDATE_MANU_LIST_SUCCESS]: (state, action) => ({
            ...state,
            updateManuListResp: action.payload,
        }),
        [UPDATE_MANU_LIST_FAILURE]: (state, action) => ({
            ...state,
            updateManuListResp: {
            result_code: 'E999',
            result_message: action.payload,
           }
        }),

        [EXCEL_MANU_LIST_DOWNLOAD_SUCCESS]: (state, action) => ({
            ...state,
            excelManuListDownloadResp: {
                data: action.payload,
                headers: action.headers
            }
        }),
        [EXCEL_MANU_LIST_DOWNLOAD_FAILURE]: (state, action) => ({
            ...state,
            excelManuListDownloadResp: {
                result_code: 'E999',
                result_message: action.payload
            }
        }),
        [ARCHIVEFILE_DOWNLOAD_SUCCESS]: (state, action) => ({
            ...state,
            ArchivefileDownloadResp: { data: action.payload, headers: action.headers },
          }),
          [ARCHIVEFILE_DOWNLOAD_FAILURE]: (state, action) => ({
            ...state,
            ArchivefileDownloadResp: {
              result_code: 'E999',
              result_message: action.payload,
            },
          }),
    },
    initialState
)

export default apiManuMngtResp
